import React, { useEffect, useState } from 'react';
import './ActualidadNav.css';
import { Link } from 'react-router-dom';
import { apiFetch } from '../../api/httpClient';
import { API_BASE_URL } from '../../config/config';

const ActualidadNav = () => {
  const [noticias, setNoticias] = useState([]);
  const STATIC_BASE_URL = API_BASE_URL.replace('/api', '');

  useEffect(() => {
    apiFetch('/noticias/ultimas')
      .then(setNoticias)
      .catch((err) => console.error('Error cargando noticias:', err));
  }, []);

  if (noticias.length === 0) return <div className="actualidad-nav-section">Cargando noticias...</div>;

  const construirImagenUrl = (imagenPath) => {
    if (!imagenPath) return null;
    // Si ya es una URL completa (Cloudinary), retornarla tal cual
    if (imagenPath.startsWith('http')) return imagenPath;
    // Si es una ruta relativa local, construir la URL completa
    if (imagenPath.startsWith('/uploads')) return `${STATIC_BASE_URL}${imagenPath}`;
    // Fallback
    return imagenPath;
  };

  return (
    <section className="actualidad-nav-section">
      <div className="actualidad-nav-container">
        <div className="news-grid-nav">
          {noticias.map((n) => {
            const imagenUrl = construirImagenUrl(n.imagenPath);
            return (
              <div className="news-item-nav" key={n.id || n.titulo}>
                {n.id ? (
                  <Link to={`/noticia/${n.id}`} className="news-link-nav">
                    <div className="news-image-nav">
                      {imagenUrl ? (
                        <img 
                          src={imagenUrl} 
                          alt={n.titulo}
                          onError={(e) => {
                            console.error('Error cargando imagen:', imagenUrl);
                            e.target.style.display = 'none';
                          }}
                        />
                      ) : (
                        <div style={{ width: '100%', height: '100%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          Sin imagen
                        </div>
                      )}
                    </div>
                    <div className="news-content-nav">
                      <h5 className="news-title-nav">{n.titulo}</h5>
                      <p className="news-description-nav">
                        {n.descripcion || (n.contenido ? n.contenido.substring(0, 100) + '...' : '')}
                      </p>
                    </div>
                  </Link>
                ) : (
                  <div className="news-item-error">No se encontró un ID para esta noticia: {n.titulo}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ActualidadNav;

